// Constants
import { PlannerPersistedObjectStoreIndexNames, PlannerPersistedObjectStoreKeys } from "@ms/uno-constants/lib/local/PersistenceConstants";
import { TableName } from "@ms/uno-constants/lib/local/StoreConstants";
import { QueryRelationship } from "../planner/EntityRelationships";
import { collection, status } from "@ms/uno-utilities/lib/local/storage/TableNameUtilities";
/** indexes for mru data */ const mruIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.MruPinnedIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for buckets data */ const bucketIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.BucketsPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** indexes for task store */ const taskIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksPlanIndex,
        isUnique: false,
        isMultiEntry: false
    },
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksMyDayDateIndex,
        isUnique: false,
        isMultiEntry: false
    },
    {
        name: PlannerPersistedObjectStoreIndexNames.TasksAssigneeIdentityIdIndex,
        isUnique: false,
        isMultiEntry: true
    }
];
/** indexes for custom fields definition data */ const cfdIndexes = [
    {
        name: PlannerPersistedObjectStoreIndexNames.CfdPlanIndex,
        isUnique: false,
        isMultiEntry: false
    }
];
/** mru object store schema */ const mruStoreSchema = {
    /** name of the object store */ name: TableName.Mru,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Mru,
    /** object store indexes */ indexes: mruIndexes
};
/** plans object store schema */ const planStoreSchema = {
    /** name of the object store */ name: TableName.Plan,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Plans,
    /** object store indexes */ indexes: []
};
/** plan status schema */ const planStatusSchema = {
    /** name of the object store */ name: status(TableName.Plan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Buckets objects store schema */ const bucketStoreSchema = {
    /** name of the object store */ name: TableName.Bucket,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Buckets,
    /** object store indexes */ indexes: bucketIndexes
};
/** buckets in plan status schema */ const bucketsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.Bucket, QueryRelationship.BucketsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks object store schema */ const taskStoreSchema = {
    /** name of the object store */ name: TableName.Tasks,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Tasks,
    /** object store indexes */ indexes: taskIndexes
};
/** tasks in plan status schema */ const tasksInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks by assignee status schema */ const tasksByAssigneeStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksAssignedToUser),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** tasks in my day status schema */ const tasksInMyDayStatusSchema = {
    /** name of the object store */ name: collection(TableName.Tasks, QueryRelationship.TasksInMyDayOfUser),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** View config objects store schema */ const viewConfigStoreSchema = {
    /** name of the object store */ name: TableName.ViewConfig,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.ViewConfig,
    /** object store indexes */ indexes: []
};
/** CFD objects store schema */ const cfdStoreSchema = {
    /** name of the object store */ name: TableName.CustomFieldDefinitions,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Cfd,
    /** object store indexes */ indexes: cfdIndexes
};
/** CFDs in plan status schema */ const cfdsInPlanStatusSchema = {
    /** name of the object store */ name: collection(TableName.CustomFieldDefinitions, QueryRelationship.CustomFieldDefinitionsInPlan),
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.Status,
    /** object store indexes */ indexes: []
};
/** Pinned tasks object store schema */ const pinnedTasksStoreSchema = {
    /** name of the object store */ name: TableName.PinnedTasks,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.PinnedTasks,
    /** object store indexes */ indexes: []
};
/** Task-order object store schema */ const taskOrderStoreSchema = {
    /** name of the object store */ name: TableName.TaskOrder,
    /** primary key */ keyPath: PlannerPersistedObjectStoreKeys.TaskOrder,
    /** object store indexes */ indexes: []
};
/** Planner browser cache async storage object store schema */ export const PersistedObjectStoreSchema = [
    mruStoreSchema,
    planStoreSchema,
    planStatusSchema,
    taskStoreSchema,
    tasksInPlanStatusSchema,
    tasksByAssigneeStatusSchema,
    tasksInMyDayStatusSchema,
    bucketsInPlanStatusSchema,
    bucketStoreSchema,
    viewConfigStoreSchema,
    cfdStoreSchema,
    cfdsInPlanStatusSchema,
    pinnedTasksStoreSchema,
    taskOrderStoreSchema
];
